import api from "../services/api";
import _ from "lodash";
import moment from "moment";
import filters from "@/core/utils/filters";

const prepareData = (summaryReportResp) => {
  const mappedResponse = summaryReportResp.map((i) => {
    return { ...i, date: filters.formatUTCDate(i.date) };
  });

  return _.groupBy(mappedResponse, "date");
};

// eslint-disable-next-line complexity
const parseStatusResponse = (summaryReportResp) => {
  const groupedByDateResponse = prepareData(summaryReportResp);

  let currentPeriod = moment().utc().startOf("isoWeek");

  const result = [];

  for (let i = 1; i <= 8; i++) {
    let row = {
      start: filters.formatUTCDate(currentPeriod),
      end: filters.formatUTCDate(moment(currentPeriod).endOf("isoWeek")),
      success: 0,
      reject: 0,
      total: 0,
    };
    let periodValue =
      groupedByDateResponse[filters.formatUTCDate(currentPeriod)];

    _.forEach(periodValue, (j) => {
      if (j.riskResult) {
        row.success += +j.count;
      } else {
        row.reject += +j.count;
      }
      row.total += +j.count;
    });

    row.success_pr = Math.round((row.success * 100) / row.total) | 0;
    row.reject_pr = row.success_pr > 0 ? 100 - row.success_pr : 0;
    result.push(row);
    currentPeriod.subtract(1, "week");
  }
  return { result };
};

// eslint-disable-next-line complexity
const parseReportResponse = (reportResp, period) => {
  const codeList = {};

  reportResp.forEach((i) => {
    codeList[i.code] = [];
  });

  const groupedByDateResponse = prepareData(reportResp);

  const unitOfTime = period === "week" ? "isoWeek" : "day";
  let currentPeriod = moment().utc().startOf(unitOfTime);

  const result = [];

  const lendthPeriod = period === "week" ? 8 : 30;
  for (let i = 1; i <= lendthPeriod; i++) {
    const endParamVal =
      period === "week"
        ? filters.formatUTCDate(moment(currentPeriod).endOf("isoWeek"))
        : filters.formatUTCDate(currentPeriod);

    let row = {
      start: filters.formatUTCDate(currentPeriod),
      end: endParamVal,
    };

    let periodValue =
      groupedByDateResponse[filters.formatUTCDate(currentPeriod)] || [];

    row.total = periodValue.reduce(function (previous, val) {
      return previous + +val.count;
    }, 0);

    Object.keys(codeList).forEach((code, key) => {
      const item = periodValue.find((o) => o.code === code);
      row[code] = item?.count | 0;
      row[`${code}_pr`] =
        (Math.round(((item?.count | 0) * 100) / row.total) || 0) + "%";

      row[`${code}_prr`] = row[code] + " " + row[`${code}_pr`];
    });

    currentPeriod.subtract(1, period);
    result.push(row);
  }
  return { result, codes: codeList };
};

export default {
  namespaced: true,
  actions: {
    getItems({ commit }, payload) {
      return api
        .getItems({ ...payload, expand: "organization" })
        .then((resp) => ({
          items: resp.data.items,
          totalCount: resp.data.count,
        }));
    },
    getStatistic: function ({ commit }, id) {
      return api.getStatistic(id).then((resp) => resp.data);
    },
    statusSummaryReport({ commit }, compId) {
      return api.loadStatusSummaryReport(compId).then(({ data }) => {
        return parseStatusResponse(data).result;
      });
    },
    summaryReport({ commit }, compId) {
      return api.loadStatusSummaryReport(compId,'week').then(({ data }) => {
        return parseReportResponse(data, "week");
      });
    },
    dailyReport({ commit }, compId) {
      return api.loadStatusSummaryReport(compId, 'day').then(({ data }) => {
        return parseReportResponse(data, "days");
      });
    },
  },
};
